export default {
    // nshop fast testfast jinsi hktest
    // baseUrl: 'https://beta.betate.com/testfast/public/',
    // baseUrl: 'https://www.blossom-power.com/fast/public/',
    baseUrl: 'https://www.advance-stationery.com/fast/public/',
	// baseUrl: 'http://hk.kkit.cc/hktest/public/',
    // baseUrl: 'https://newfast.kkit.cc/fast/public/',
	// baseUrl: 'http://127.0.0.1/fast/public/',
	
    // baseUrl: 'fast/public/',
    // imgUrl: 'https://beta.betate.com/testfast/public/',
	imgUrl: 'https://www.advance-stationery.com/fast/public/',
    // imgUrl: 'https://www.blossom-power.com/fast/public/',
    // imgUrl: 'http://hk.kkit.cc/hktest/public/',
    // imgUrl: 'http://127.0.0.1/fast/public/',
	
    // imgUrl: 'fast/public',
}